import { Link, useParams } from 'react-router'
import Table from '../Components/AdminTable.js'
import { useEffect, useState } from 'react'
import { call } from '../Methods.js'
import { use } from '../Helpers.js'
import FormModal from '../Components/FormModal.js'

function ExamTypes () {
  const pageName = 'examTypes'
  const pageTitle = 'İmtahan növləri'
  document.title = `${pageTitle} | ${process.env.REACT_APP_NAME}`
  const [updateTable, setUpdateTable] = useState(false)

  useEffect(() => {
    if (updateTable) {
      setUpdateTable(false)
    }
  }, [updateTable])

  const tableSettings = {
    name: '',
    label: '',
    filters: true,
    pagination: true,
    editLink: rowData => `/${pageName}/${rowData.id}`,
    actions: {
      get: async (params = {}) => {
        const examTypes = await call.forLoggedUser.examType.getExamTypes(params)
        if (examTypes.success) {
          return examTypes.data
        }
        return []
      }
    },
    columns: [
      {
        title: '#',
        property: 'rowNumber',
        style: { width: '30px' },
        filter: {
          enabled: false
        }
      },
      {
        title: 'İmtahan növünün adı',
        property: 'name',
        style: { width: '30%' },
        filter: {
          enabled: true,
          type: 'text',
          name: 'name'
        }
      },
      {
        title: 'Forma',
        property: 'examFormName',
        style: { width: '10%' },
        filter: {
          enabled: true,
          type: 'select',
          name: 'examFormId',
          dataSource: async () => {
            const source = await call.forLoggedUser.listOption.getListOptions({
              listName: 'examForm'
            })
            let data = source.data.map(d => {
              return { value: d.value, text: d.text }
            })
            return data
          }
        }
      },

      {
        title: 'Mühit',
        property: 'examModeName',
        style: { width: '10%' },
        filter: {
          enabled: true,
          type: 'select',
          name: 'examModeId',
          dataSource: async () => {
            const source = await call.forLoggedUser.listOption.getListOptions({
              listName: 'examMode'
            })
            let data = source.data.map(d => {
              return { value: d.value, text: d.text }
            })
            return data
          }
        }
      },
      {
        title: 'Fənn(lər)',
        type: 'labels',
        property: 'subjectList',
        style: { width: '30%' },
        filter: {
          enabled: true,
          type: 'select',
          name: 'subjectId',
          dataSource: async () => {
            const source = await call.forLoggedUser.subject.getSubjects({})
            let data = source.data?.map(d => {
              return { value: d.id, text: d.name }
            })
            return data
          }
        },
        mutate: value => {
          return value?.map(s => s.subjectName)
        }
      },
      {
        title: 'Status',
        type: 'status-label',
        property: ['statusId', 'statusName'],
        style: { width: '10%' },
        filter: {
          enabled: true,
          type: 'select',
          name: 'statusId',
          dataSource: async () => {
            const source = await call.forLoggedUser.status.getStatuses({
              type: 'examType'
            })
            let data = source.data?.map(d => {
              return { value: d.id, text: d.description }
            })
            return data
          }
        },
        mutate: values => {
          return values[1]
        }
      },
      {
        title: 'Əməliyyat',
        property: ['id'],
        type: 'operations-list',
        operations: values => [
          {
            type: 'group',
            name: 'menu',
            title: 'Group',
            icon: '...',
            items: [
              {
                type: 'command',
                name: 'delete',
                warning: `İmtahan tipinə aid bütün məlumatlar, o cümlədən, \n - İmtahanlar \n - İmtahanlardakı iştirak və nəticə \n məlumatları birdəfəlik silinəcək.`,
                parameters: JSON.stringify({
                  id: values[0],
                  entity: 'examType'
                }),
                iconType: 'path',
                icon: '/Images/Icons/delete.png',
                disablingConditions: []
              }
            ]
          }
        ],
        style: { width: '5%', minWidth: '50px' }
      }
    ],
    addNew: {
      enabled: true,
      url: `/${pageName}/add`,
      title: '+ Əlavə et'
    }
  }

  const formSettings = [
    {
      name: 'examtype',
      id: '',
      label: 'İmtahan növü',
      isStandAlone: true,
      isMain: true,
      actions: {
        get: id => call.forLoggedUser.examType.getExamTypeById({ id: id }),
        add: call.forLoggedUser.examType.addExamType,
        edit: call.forLoggedUser.examType.updateExamType
      },
      formLists: {
        ExamForms: async () => {
          const source = await call.forLoggedUser.listOption.getListOptions({
            listName: 'examForm'
          })
          return source.data.map(d => {
            return { value: d.value, text: d.text }
          })
        },
        ExamModes: async () => {
          const source = await call.forLoggedUser.listOption.getListOptions({
            listName: 'examMode'
          })
          return source.data.map(d => {
            return { value: d.value, text: d.text }
          })
        },
        Courses: async () => {
          const source = await call.forLoggedUser.course.getCourses({})
          let data = source.data?.map(s => {
            return { value: s.id, text: s.name }
          })
          return data
        },
        Subjects: async () => {
          const source = await call.forLoggedUser.subject.getSubjects({})
          let data = source.data?.map(s => {
            return { value: s.id, text: s.name }
          })
          return data
        },
        Statuses: async () => {
          const source = await call.forLoggedUser.status.getStatuses({
            type: 'examType'
          })
          return source.data.map(d => {
            return { value: d.id, text: d.description }
          })
        }
      },
      fields: [
        { type: 'hidden', fieldName: 'id', label: '' },
        {
          label: 'Adı',
          type: 'text',
          validationRules: ['required'],
          fieldName: 'name',
          col: { sm: 4 }
        },
        {
          label: 'İmtahan forması',
          type: 'select',
          fieldName: 'examFormId',
          data: 'ExamForms',
          col: { sm: 2 }
        },
        {
          label: 'Mühit',
          type: 'select',
          fieldName: 'examModeId',
          data: 'ExamModes',
          col: { sm: 2 }
        },
        {
          label: 'Müddət (dəq.)',
          type: 'number',
          defaultValue: 0,
          fieldName: 'duration',
          col: { sm: 2 }
        },
        {
          label: 'Keçid balı',
          type: 'number',
          defaultValue: 0,
          fieldName: 'passingScore',
          col: { sm: 1 }
        },
        {
          label: 'Maks. bal',
          type: 'number',
          defaultValue: 100,
          fieldName: 'maximumScore',
          col: { sm: 1 }
        },
        {
          label: 'Təlim iştirakçıları',
          type: 'select-multiple',
          data: 'Courses',
          fieldName: 'courses',
          col: { sm: 12 }
        },
        {
          label: 'Fənn(lər)',
          type: 'select-multiple',
          data: 'Subjects',
          validationRules: ['required'],
          fieldName: 'subjects',
          col: { sm: 12 }
        },
        {
          label: 'Açıqlamalar',
          type: 'textarea',
          fieldName: 'description',
          col: { sm: 12 }
        },
        {
          label: 'Status',
          type: 'select',
          fieldName: 'statusId',
          col: { sm: 3 },
          defaultValue: 0,
          data: 'Statuses'
        },
        { type: 'submit', label: 'Təsdiq', col: { sm: 12 } }
      ]
    },
    {
      name: 'exams',
      id: '',
      label: 'Bu növ üzrə keçirilmiş imtahanlar',
      isStandAlone: false,
      isMain: false,
      actions: {
        get: id => call.forLoggedUser.exam.getExams({ examTypeId: id })
      },
      formLists: {
        Statuses: async () => {
          const source = await call.forLoggedUser.status.getStatuses({
            type: 'exam'
          })
          let data = source.data.map(d => {
            return { value: d.id, text: d.description }
          })
          return data
        }
      },
      fields: [
        { type: 'hidden', fieldName: 'examTypeId', label: '' },
        {
          label: 'İmtahan növü',
          fieldName: 'examTypeName',
          type: 'readonly-text',
          col: { sm: 3 }
        },
        {
          label: 'İmtahanlar',
          single: 'imtahan',
          type: 'input-group-row',
          fieldName: 'exams',
          defaultValue: [],
          addRowPermission: false,
          multipleRows: true,
          removeRowPermission: true,
          rowStyleRules: [
            {
              fieldName: 'id',
              getStyleRule: value =>
                value < 0 ? { backgroundColor: '#ffd4d4' } : {}
            }
          ],
          rowFields: [
            {
              label: '',
              type: 'hidden',
              fieldName: 'id'
            },
            {
              label: '',
              type: 'hidden',
              fieldName: 'examTypeId'
            },
            {
              label: '',
              type: 'select',
              fieldName: 'examId'
            },
            {
              label: 'Tarix',
              type: 'date',
              fieldName: 'date',
              columnWidth: '10%'
            },
            {
              label: 'Saat',
              type: 'time',
              fieldName: 'time',
              columnWidth: '10%'
            },
            {
              label: 'İştirakçı sayı',
              type: 'number',
              fieldName: 'participantCount',
              columnWidth: '10%'
            },
            {
              label: 'Orta nəticə',
              type: 'number',
              fieldName: 'averageResult',
              columnWidth: '10%'
            },
            {
              label: 'Qeydlər',
              type: 'textarea',
              columnWidth: '15%',
              fieldName: 'notes'
            },
            {
              label: 'Status',
              type: 'select',
              fieldName: 'statusId',
              disabled: true,
              defaultValue: 0,
              columnWidth: '15%',
              data: 'Statuses'
            },
            {
              label: 'Əməliyyatlar',
              type: 'operations',
              fieldName: 'id',
              columnWidth: '20%',
              operations: []
            }
          ]
        },
        { type: 'submit', label: 'Yadda saxla', col: { sm: 12 } }
      ]
    }
  ]

  return (
    <div className='page'>
      <h1 className='page-title'>{pageTitle}</h1>
      {/* <h5 className='page-description'>Bu səhifə kursun təşkil etdiyi bütün təlimlərin göstərilməsi, əlavə olunması və düzəlişlərin aparılması üçündür.</h5> */}
      <Table tableSettings={tableSettings} updateTable={updateTable} />

      <FormModal
        moduleUrl={`/${pageName}`}
        formSettings={formSettings}
        onSubmit={() => setUpdateTable(true)}
      />
    </div>
  )
}

export default ExamTypes
